import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../lib/api";

const Login = () => {

  const navigate = useNavigate();

  const [isRegister, setIsRegister] = useState(false);

  const [name, setName] = useState("");

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  /*
  |--------------------------------------------------------------------------
  | AUTH SUBMIT
  |--------------------------------------------------------------------------
  */

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    setError("");

    try {

      let res;

      /*
      |--------------------------------------------------------------------------
      | REGISTER
      |--------------------------------------------------------------------------
      */

      if (isRegister) {

        res = await API.post("/register", {

          name,
          email,
          password,

        });

      }

      /*
      |--------------------------------------------------------------------------
      | LOGIN
      |--------------------------------------------------------------------------
      */

      else {

        res = await API.post("/login", {

          email,
          password,

        });
      }

      /*
      |--------------------------------------------------------------------------
      | SAVE AUTH
      |--------------------------------------------------------------------------
      */

      localStorage.setItem(
        "token",
        res.data.token
      );

      localStorage.setItem(
        "user",
        JSON.stringify(res.data.user)
      );

      navigate("/");

    }

    catch (err) {

      setError(

        err.response?.data?.message ||

        `${isRegister ? "Registration" : "Login"} failed`

      );

    }

    finally {

      setLoading(false);

    }
  };

  return (

    <div className="min-h-screen flex items-center justify-center bg-[#050816] px-4 overflow-hidden relative">

      {/* GLOW EFFECTS */}

      <div className="absolute w-[450px] h-[450px] bg-purple-600/20 blur-3xl rounded-full top-[-100px] left-[-100px]" />

      <div className="absolute w-[350px] h-[350px] bg-blue-600/20 blur-3xl rounded-full bottom-[-100px] right-[-100px]" />

      {/* CARD */}

      <div className="relative w-full max-w-md bg-[#0F172A]/80 backdrop-blur-2xl border border-white/10 rounded-3xl shadow-2xl p-8">

        {/* LOGO */}

        <div className="flex justify-center mb-6">

          <div className="w-14 h-14 rounded-2xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
            ✦
          </div>

        </div>

        {/* TITLE */}

        <h1 className="text-3xl font-bold text-center text-white mb-2">
          {isRegister
            ? "Create Account"
            : "Welcome Back"}
        </h1>

        <p className="text-center text-gray-400 mb-8">
          {isRegister
            ? "Start building apps with AI"
            : "Login to continue"}
        </p>

        {/* ERROR */}

        {error && (

          <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm p-3 rounded-xl mb-5">

            {error}

          </div>
        )}

        {/* FORM */}

        <form
          onSubmit={handleSubmit}
          className="space-y-5"
        >

          {/* NAME */}

          {isRegister && (

            <div>

              <label className="text-sm text-gray-400">
                Full Name
              </label>

              <input
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) =>
                  setName(e.target.value)
                }
                required
                className="w-full mt-2 px-4 py-3 bg-[#0B1120] border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
              />

            </div>
          )}

          {/* EMAIL */}

          <div>

            <label className="text-sm text-gray-400">
              Email
            </label>

            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
              required
              className="w-full mt-2 px-4 py-3 bg-[#0B1120] border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            />

          </div>

          {/* PASSWORD */}

          <div>

            <label className="text-sm text-gray-400">
              Password
            </label>

            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              required
              className="w-full mt-2 px-4 py-3 bg-[#0B1120] border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            />

          </div>

          {/* BUTTON */}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold shadow-lg hover:opacity-90 transition-all"
          >

            {loading
              ? isRegister
                ? "Creating Account..."
                : "Signing In..."
              : isRegister
                ? "Create Account"
                : "Sign In"}

          </button>

        </form>

        {/* TOGGLE */}

        <div className="mt-6 text-center text-sm text-gray-400">

          {isRegister
            ? "Already have an account?"
            : "Don't have an account?"}

          <button
            onClick={() =>
              setIsRegister(!isRegister)
            }
            className="ml-2 text-purple-400 hover:text-purple-300 font-medium"
          >

            {isRegister
              ? "Sign In"
              : "Register"}

          </button>

        </div>

        {/* FOOTER */}

        <p className="text-center text-xs text-gray-500 mt-8">
          Powered by
          <span className="text-white ml-1">
            Techspr AI
          </span>
        </p>

      </div>
    </div>
  );
};

export default Login;